import LTButton from 'new-theme/components/LTComponents/LTButton/LTButton';
import { LTCopyToClipboard } from '@lambdatestincprivate/lt-components';
import './style.css';

const CopyText = ({
  className,
  onClick,
  onKeyDown,
  text,
  variant = LTButton.Variant.INVISIBLE,
  useNavigator = false,
}) => {
  return (
    <LTCopyToClipboard
      textToCopy={text}
      onCopy={onClick}
      useNavigator={useNavigator}
    />
  );
};

export default CopyText;
